import { render, staticRenderFns } from "./examlogin.vue?vue&type=template&id=4ee71b70&scoped=true"
import script from "./examlogin.vue?vue&type=script&lang=js"
export * from "./examlogin.vue?vue&type=script&lang=js"
import style0 from "./examlogin.vue?vue&type=style&index=0&id=4ee71b70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee71b70",
  null
  
)

export default component.exports